export type NominationTrack = "education" | "technology"

export interface NominationFrontImageStyle {
  width: string
  top?: string
  right?: string
  bottom?: string
  left?: string
}

export interface NominationFrontGlowStyle {
  width: string
  height: string
  top: string
  left: string
}

export interface NominationLayoutConfig {
  id: number
  track: NominationTrack
  frontTitleWidth: string
  frontImage: NominationFrontImageStyle
  frontGlow: NominationFrontGlowStyle
}

interface NominationLayoutList extends Array<NominationLayoutConfig> {}

export const nominations: NominationLayoutList = [
  {
    id: 10,
    track: "education",
    frontTitleWidth: "243px",
    frontImage: {
      width: "60%",
      right: "5%",
      bottom: "-10%",
    },
    frontGlow: {
      width: "524px",
      height: "524px",
      top: "74%",
      left: "24%",
    },
  },
  {
    id: 8,
    track: "education",
    frontTitleWidth: "100%",
    frontImage: {
      width: "83%",
      right: "3%",
      bottom: "-24%",
    },
    frontGlow: {
      width: "432px",
      height: "432px",
      top: "70%",
      left: "32%",
    },
  },
  {
    id: 11,
    track: "education",
    frontTitleWidth: "319px",
    frontImage: {
      width: "87%",
      right: "-12%",
      bottom: "4%",
    },
    frontGlow: {
      width: "422px",
      height: "422px",
      top: "70%",
      left: "36%",
    },
  },
  {
    id: 12,
    track: "education",
    frontTitleWidth: "353px",
    frontImage: {
      width: "57%",
      right: "10%",
      bottom: "7%",
    },
    frontGlow: {
      width: "608px",
      height: "608px",
      top: "74%",
      left: "20%",
    },
  },
  {
    id: 1,
    track: "education",
    frontTitleWidth: "333px",
    frontImage: {
      width: "44%",
      right: "5%",
      bottom: "7%",
    },
    frontGlow: {
      width: "648px",
      height: "648px",
      top: "74%",
      left: "40%",
    },
  },
  {
    id: 17,
    track: "technology",
    frontTitleWidth: "345px",
    frontImage: {
      width: "37%",
      right: "11%",
      bottom: "-21%",
    },
    frontGlow: {
      width: "610px",
      height: "610px",
      top: "76%",
      left: "22%",
    },
  },
  {
    id: 18,
    track: "technology",
    frontTitleWidth: "372px",
    frontImage: {
      width: "44%",
      right: "9%",
      bottom: "-23%",
    },
    frontGlow: {
      width: "620px",
      height: "620px",
      top: "78%",
      left: "20%",
    },
  },
  {
    id: 19,
    track: "technology",
    frontTitleWidth: "292px",
    frontImage: {
      width: "76%",
      right: "9%",
      bottom: "-6%",
    },
    frontGlow: {
      width: "560px",
      height: "560px",
      top: "76%",
      left: "26%",
    },
  },
  {
    id: 13,
    track: "technology",
    frontTitleWidth: "100%",
    frontImage: {
      width: "65%",
      right: "-2%",
      bottom: "-24%",
    },
    frontGlow: {
      width: "620px",
      height: "620px",
      top: "74%",
      left: "34%",
    },
  },
  {
    id: 15,
    track: "technology",
    frontTitleWidth: "100%",
    frontImage: {
      width: "68%",
      right: "16%",
      bottom: "-20%",
    },
    frontGlow: {
      width: "600px",
      height: "600px",
      top: "74%",
      left: "30%",
    },
  },
]
